<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleStockIn',
  components: {
    PageTable,
  },
}
</script>
